import { Crud } from "./crud";

export class AreaTypeResource extends Crud {

    constructor() {
        super('area-types');
    }
}